module.exports = __webpack_public_path__ + "static/localiza-a4755b7dbe0d8f33e41075e5ead22c65.png";